import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as loaderAction from "../../redux/loader/action";
import { getGameName } from "../../components/shared/utils";
import cx from "classnames";
import { GuessCard } from "../../components/card";

class GameScreen extends Component {
  componentDidMount() {
    // this.props.setIsLoading(true);
    let roomObj = this.props.gameReducer.roomObj;
    const gameName = getGameName(roomObj);
    if (
      Object.keys(roomObj).length >= 0 &&
      gameName === "GAH" &&
      roomObj &&
      roomObj.game_state.status === "Joining"
    ) {
      // this.props.setIsLoading(true);
    }
    // this.props.setIsLoading(false);
    // if (roomObj.game_state.status === "PrePlay") {
    // }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let roomObj = nextProps.gameReducer.roomObj;

    const gameName = getGameName(roomObj);
    if (
      Object.keys(roomObj).length > 0 &&
      gameName === "GAH" &&
      roomObj &&
      roomObj.game_state.status === "PrePlay" &&
      nextProps.loaderDetails.isLoading
    ) {
      // nextProps.setIsLoading(false);
    }
  }

  renderList(endCurrentRound, showClues, validClues) {
    let prompt = "";
    const roomData = this.props.gameReducer.roomObj;
    const gameName = getGameName(roomData);

    let text = "Waiting for clues...";
    if (showClues && validClues.length <= 0) {
      text = "No Clues";
    }
    if (roomData && gameName === "GAH") {
      prompt = true;
      text = "Waiting for prompt...";
    }
    if (roomData?.game_state?.status === "Judging") {
      text = "Waiting on Referee...";
    }

    if (endCurrentRound) {
      this.props.history.replace("/result");
    }
    if (
      prompt &&
      roomData.game_state &&
      roomData.game_state.status === "Playing"
    ) {
      this.props.history.replace("/prompt");
    } else {
      return (
        <div className="h-100 d-flex align-items-center justify-content-center">
          <h3
            className={cx("text-light waiting-txt-gah", {
              waitingTxtTW: roomData.game_code === "TW"
            })}
          >
            <b>{text}</b>
          </h3>
        </div>
      );
    }
  }

  render() {
    const roomData = this.props.gameReducer.roomObj;
    const gameName = getGameName(roomData);
    let showClues = false;
    let allUsers = roomData.users;
    const clues = roomData.game_state.clues;
    if (roomData) {
      if (roomData.game_code === "TW") {
        if (roomData.game_state) {
          let status = roomData.game_state.status;

          if (status === "Over") {
            return <Redirect to={"/final-result"} />;
          }
          if (status === "Result") {
            return <Redirect to={"/result"} />;
          }
        }
      } else if (gameName === "GAH") {
        let status = roomData.game_state.status;
        if (status === "Result") return <Redirect to={"/result"} />;
        // if (status === "Joining" ) {
        //   return <Redirect to={"/lobby"} />;
        // }
      }
      if (
        roomData &&
        Object.keys(roomData).length > 0 &&
        !roomData.active_game
      ) {
        return <Redirect to={"/"} />;
      }
    }

    let validClues = [];

    if (clues && clues.length > 0) {
      validClues = clues.filter((val) => val.valid === true);
    }
    // let mystery_word = "Loading...";
    let activePlayerGuess = "";
    let showGuess = false;
    let activePlayerName = "";
    let activePlayerImage = "";
    let endCurrentRound = false;
    if (roomData.game_state) {
      if (roomData.game_state.status === "Result") {
        endCurrentRound = true;
      }
      // if (roomData?.game_state?.mystery_word?.word) {
      //   mystery_word = roomData.game_state.mystery_word.word;
      // }
      if (roomData?.game_state?.guess) {
        activePlayerGuess = roomData.game_state.guess;
      }

      if (roomData?.game_state?.status) {
        if (
          roomData.game_state.status === "Guessing" ||
          roomData.game_state.status === "Evaluating"
        ) {
          showClues = true;
        }
        if (
          roomData.game_state.status === "Result" ||
          roomData.game_state.status === "Evaluating"
        ) {
          showGuess = true;
        }
      }
      const activePlayer = allUsers.find(
        (user) => user.player_id === roomData.game_state.active_player
      );
      if (activePlayer) {
        activePlayerName = activePlayer.display_name;
        activePlayerImage = activePlayer.profile_image;
      }
    }

    return (
      <div className="gamesWrapper twGamesWrapper">
        {showClues && validClues && validClues.length > 0 ? (
          <div className="gamesResults">
            {validClues.map((clue) => {
              const user = allUsers.find(
                (user) => user.player_id === clue.player_id
              );
              return (
                <div className="item">
                  <button className="clueBtn">{clue.word}</button>
                  <div className="person">
                    <div className="personImageWrapper">
                      <div className="holder">
                        <img
                          className="personImage"
                          src={user ? user.profile_image : ""}
                        />
                      </div>
                    </div>
                    <div className="personNameWrapper">
                      <p className="personName">
                        {user ? user.display_name : ""}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <>{this.renderList(endCurrentRound, showClues, validClues)}</>
        )}

        {showGuess && (
          <>
            <Row>
              <Col md={9}>
                <GuessCard
                  image={activePlayerImage}
                  personName={activePlayerName}
                  btnText={activePlayerGuess}
                />
              </Col>
            </Row>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GameScreen);
